import React, {Component} from 'react';
import { Alert, Button } from 'react-bootstrap';
import axios from 'axios';
import _ from 'lodash';

import {connect} from 'react-redux';
import {fetchUserToken} from '../../redux/actions';
import {ROOT_URL} from  '../../redux/actions/';
// const ROOT_URL = "http://52.221.35.108:9374";

class DescriptionPanel extends Component{
  constructor(props){
    super(props);
    this.state = {
      chosenColor: null,
      chosenNum: 1,
      successMessage: '',
    };
  }

  onNumberInputChange = (event) => {
    this.setState({
      chosenNum: event.target.value
    });
  }

  handleIncreaseNumber = () => {
    this.setState({
      chosenNum: this.state.chosenNum + 1
    });
  }

  handleDecreaseNumber = () => {
    if (parseInt(this.state.chosenNum, 10) > 1) {
      this.setState({
        chosenNum: this.state.chosenNum - 1
      });
    }
  }

  onColorInputChoson = (event) => {
    // reset state chosenNum;
    const chosenColor = event.target.getAttribute('value');
    this.setState({
      chosenColor: chosenColor
    });
  }

  onAddToCartSubmit = () => {
    const {chosenNum} = this.state;
    const {userToken} = this.props;
    const {id} = this.props.desc;
    console.log('HERE WE ARE!!!', this.state)
      let requestBody = {
        token: userToken,
        flowerId: id,
        color:{['#F17013']: chosenNum}
      };
      axios.post(`${ROOT_URL}/visitor/shoppingCartAdd`, requestBody).then((result) => {
        console.log(result.data)
        this.setState({
          successMessage: result.data
        });

        // show successAlert
        let successAlert = document.querySelector('#successAlert');
        successAlert.style.display = 'block';
        window.location.reload();
        setTimeout(() => {
          successAlert.style.display = 'none';
        }, 2000);        
      });
  }

  getColorList = (colorList) => {
    return colorList.map((color)=>{
        const blockStyle = {
          margin: "0 0.5em",
          display: "inline-block",
          background: color,
          borderRadius: "0.2em",
          width: "2em",
          height: "2em",
          verticalAlign: "center"
        }
        return(
          <span
            key={color}
            className="singleItemColorBlock"
            value={color}
            style={blockStyle}
            onClick={this.onColorInputChoson}>
          </span>)
    });
  }

  componentDidMount(){
    if(_.isEmpty(this.props.userToken)){
      this.props.fetchUserToken();
    }
  }
 
  
  showPrice( category, subcategory){
     console.log("Subcat is "+subcategory)
     if(category === "DECORATIONS" ){

       if(subcategory === "GRACE" || subcategory === "FAME"|| subcategory === "INTERIOR" )
       return false;
       else 
       return true;
     }
     else if (category == "WEDDING"){
      if(subcategory === "BRIDAL CAR" || subcategory === "DECORATION BLISS"|| subcategory === "DECORATION JOY" || subcategory == "DECORATION MIRTH" )
      return false;
      else 
      return true;
     }
     else
     return true
  }
  
  render(){
    const {desc, dynamicClass} = this.props;
    
    return(
      <div className={`DescriptionPanel ${dynamicClass}`}>
        <div className='noname'>
          {/* <div className="SingleItemCap2">Preserved Flower</div> */}
          <div className="SingleItemCap4">
            <span>{desc.availability}</span>
          </div>
          <div className="SingleItemCap1">{desc.name}</div>
        {/*isLoggedIn ? 'currently' : 'not'*/ }
        {/*<div className="SingleItemCap2">HKD ${desc.wholePrice}</div>*/}
        { this.showPrice(desc.category, desc.subcategory) ? <div className="SingleItemCap2">HKD ${desc.wholePrice}</div> : <div></div>}
          {
           /* desc.flowerPrice !== -1 ? <div className="SingleItemCap4">Fresh Flower: ${desc.flowerPrice}</div> : <div id='empty'></div>
          */}
          
          {/*<div className="SingleItemCap4">Size: H:{desc.height} W:{desc.width}</div>*/}
          <div className="SingleItemCap4">Flower Type: {desc.category}</div>
          {/* <div className="SingleItemCap4 SingleItemColorList">
            <span>Colour</span>
            {this.getColorList(desc.color)}
          </div> */}

          <Alert id="errorAlert" bsStyle="danger">You havent choose a color!</Alert>
          <Alert id="successAlert" bsStyle="success">{this.state.successMessage}</Alert>

          <div className="form-group" id="OrderNumberInputBox" >
            <div className="OrderQuantity">
              <Button onClick={this.handleDecreaseNumber}>-</Button>
              <input
                className="form-control"
                type="text"
                value={this.state.chosenNum}
                onChange={this.onNumberInputChange}/>
              <Button id="increaseNumButton" onClick={this.handleIncreaseNumber}>+</Button>
            </div>
            <button
              type="submit"
              className="btn btn-success"
              onClick={this.onAddToCartSubmit}>
              <i className="fa fa-shopping-cart" aria-hidden="true"></i>
              Add To Cart
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state){
  return ({
    shoppingCartItem: state.shoppingCartItem,
    userToken: state.userToken
  });
}

export default connect(mapStateToProps, {fetchUserToken})(DescriptionPanel);



// WEBPACK FOOTER //
// ./src/components/singleItem/descriptionPanel.js